var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.626,
    height: 58.731,
    viewBox: "0 0 60.626 58.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .nh-cls-1{fill:#ffa000}.nh-cls-3{fill:#ffd54f}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__box_1_",
    "data-name": "box (1)",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_836",
    d: "M107.575 216h-41.68A1.9 1.9 0 0 0 64 217.895v17.051a1.894 1.894 0 0 0 1.247 1.781l20.84 13.262a1.9 1.9 0 0 0 1.3 0l20.84-13.262a1.9 1.9 0 0 0 1.247-1.781v-17.051a1.9 1.9 0 0 0-1.899-1.895z",
    className: "nh-cls-1",
    "data-name": "Path 836",
    transform: "translate(-56.422 -183.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_837",
    fill: "#ffc107",
    d: "M276.84 216H256v34.1a1.9 1.9 0 0 0 .648-.114l20.84-13.262a1.9 1.9 0 0 0 1.247-1.781v-17.048A1.9 1.9 0 0 0 276.84 216z",
    "data-name": "Path 837",
    transform: "translate(-225.687 -183.371)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2800",
    "data-name": "Group 2800",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_838",
    d: "M30.351 12.547L7.919 26 0 21.262 22.772 8z",
    className: "nh-cls-3",
    "data-name": "Path 838",
    transform: "translate(0 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_839",
    d: "M286.595 164.736L263.936 178l-7.616-4.547L278.714 160z",
    className: "nh-cls-3",
    "data-name": "Path 839",
    transform: "translate(-225.969 -142.002)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_840",
    d: "M111.705 59.851L89.311 73.3 66.88 59.851 89.311 46.4z",
    className: "nh-cls-1",
    "data-name": "Path 840",
    transform: "translate(-58.961 -33.853)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2801",
    "data-name": "Group 2801",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_841",
    d: "M7.919 160l22.431 13.451L22.772 178 0 164.736z",
    className: "nh-cls-3",
    "data-name": "Path 841",
    transform: "translate(0 -142.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_842",
    d: "M286.595 21.262L278.714 26 256.32 12.547 263.936 8z",
    className: "nh-cls-3",
    "data-name": "Path 842",
    transform: "translate(-225.969 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHeader);
export default __webpack_public_path__ + "static/media/no-header.662fce0073fc4b5cd1025a214c89ab35.svg";
export { ForwardRef as ReactComponent };